import * as React from 'react';
const SvgHeartFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" height="1em" viewBox="0 0 12 11" width="1em" {...props}>
        <path
            d="M6.292 10.908a.51.51 0 01-.584 0C4.504 10.08 0 6.779 0 3.66 0-.433 4.71-1.088 6 1.669c1.29-2.757 6-2.102 6 1.991 0 3.12-4.504 6.421-5.708 7.248z"
            fill="currentColor"
        />
    </svg>
);
export default SvgHeartFilled;
